import {api} from '@/http'

// 合同列表
const getContractList = (data, callback, back) => {
  api('/api/HeTong/List', 'post', data, callback, back)
}
// 合同列表
const getExamineList = (data, callback, back) => {
  api('/api/HeTong/ExamineList', 'post', data, callback, back)
}
// 报销审核列表
const getBXExamineList = (data, callback, back) => {
  api('/api/HeTong/BXExamineList', 'post', data, callback, back)
}
// 批量确认发放
const ffExpense = (data, callback, back) => {
  api('/api/HeTong/FF', 'post', data, callback, back)
}
// 批量归档
const gdHeTongList = (data, callback, back) => {
  api('/api/HeTong/GDHeTongList', 'post', data, callback, back)
}
// 审核人员列表
const getSPUserList = (data, callback, back) => {
  api('/api/HeTong/SPUserList', 'post', data, callback, back)
}
// 合同添加
const addContract = (data, callback, back) => {
  api('/api/HeTong/Insert', 'post', data, callback, back)
}
// 合同审核通过
const examineContract = (data, callback, back) => {
  api('/api/HeTong/Examine', 'post', data, callback, back)
}
// 合同审核通过
const pgExamine = (data, callback, back) => {
  api('/api/GongZhang/PGExamine', 'post', data, callback, back)
}
// 合同归档
const gdContract = (data, callback, back) => {
  api('/api/HeTong/GD', 'post', data, callback, back)
}

// 合同详情
const detailContract = (id, callback, back) => {
  api('/api/GongZhang/Detail', 'post', {Id: id}, callback, back)
}

// 合同删除
const delContract = (id, callback, back) => {
  api('/api/HeTong/Delete', 'post', {Id: id}, callback, back)
}

// 合同公章申请
const submitGZContract = (id, callback, back) => {
  api('/api/HeTong/SubmitGZ', 'post', {Id: id}, callback, back)
}

// 车辆列表
const getCarList = (data, callback, back) => {
  api('/api/Car/List', 'post', data, callback, back)
}

// 车辆删除
const delCar = (id, callback, back) => {
  api('/api/Car/Delete', 'post', {Id: id}, callback, back)
}

// 车辆添加
const addCar = (data, callback, back) => {
  api('/api/Car/Insert', 'post', data, callback, back)
}

// 车辆限行详情
const xxCar = (callback, back) => {
  api('/api/Car/XianXingDetail', 'post', {}, callback, back)
}

// 车辆限行保存
const xxCarSave = (data, callback, back) => {
  api('/api/Car/XianXingSave', 'post', data, callback, back)
}

// 车辆记录
const getCarRecordList = (data, callback, back) => {
  api('/api/Car/RecordList', 'post', data, callback, back)
}

// 车辆导出
const exportCarRecord = (data, callback, back) => {
  api('/api/Car/Export', 'post', data, callback, back)
}

// 信息列表
const getNewsList = (data, callback, back) => {
  api('/api/News/List', 'post', data, callback, back)
}

// 信息详情
const getNewsDesc = (id, callback, back) => {
  api('/api/News/NewsDetail', 'post', {Id: id}, callback, back)
}

// 信息删除
const delNews = (id, callback, back) => {
  api('/api/News/Delete', 'post', {Id: id}, callback, back)
}

// 信息添加
const addNews = (data, callback, back) => {
  api('/api/News/Insert', 'post', data, callback, back)
}

export default {
  getContractList,
  examineContract,
  getExamineList,
  ffExpense,
  gdHeTongList,
  pgExamine,
  getBXExamineList,
  getSPUserList,
  addContract,
  gdContract,
  detailContract,
  delContract,
  submitGZContract,
  getCarList,
  delCar,
  addCar,
  xxCar,
  xxCarSave,
  getCarRecordList,
  exportCarRecord,
  delNews,
  getNewsList,
  getNewsDesc,
  addNews
}



// WEBPACK FOOTER //
// ./src/api/manage/index.js